module.exports = __webpack_public_path__ + "img/create-wallet-m-4.b0d85524.png";